import React from 'react';
import './UnderConstruction.css';

export default function UnderConstructionDashboard() {
  return (
    <div className="container py-5">
      <div className="text-center mb-5">
        <h1>🚧 Dashboard Under Construction</h1>
        <p>We're currently building this dashboard to help you monitor and analyze DualSense 5 test reports. Features like result charts, device activity logs, and report summaries will be available soon.</p>
      </div>

      <div className="row g-4">
        {/* Line Chart Placeholder */}
        <div className="col-md-8">
          <div className="widget-box">
            <div className="chart-skeleton">
              {[40, 60, 30, 50, 70, 20].map((h, i) => (
                <div key={i} className="chart-bar" style={{ height: `${h}%` }} />
              ))}
            </div>
          </div>
        </div>

        {/* Pie Chart Placeholder */}
        <div className="col-md-4">
          <div className="widget-box text-center">
            <div className="pie-skeleton mx-auto"></div>
          </div>
        </div>

        {/* Table Placeholder */}
        <div className="col-12">
          <div className="widget-box">
            <div className="table-skeleton">
              {[...Array(4)].map((_, row) => (
                <div key={row} className="table-row">
                  {[...Array(4)].map((_, col) => (
                    <div key={col} className="cell-placeholder" />
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Activity Placeholder */}
        <div className="col-12">
          <div className="widget-box">
            <div className="activity-skeleton">
              {[60, 80, 40, 70].map((w, i) => (
                <div key={i} className="activity-line" style={{ width: `${w}%` }} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
